import * as React from 'react';

import { Group, Logo } from './AssetPairLoading.styled';

const AssetPairLoading = ({ large = false }: { large?: boolean }) => (
    <Group aria-hidden="true">
        <Logo $large={large} $width={large ? '8rem' : '3.2rem'} $circle />
        <Logo $large={large} $width={large ? '8rem' : '3.2rem'} $circle />
    </Group>
);

export default AssetPairLoading;
